import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import axios from "axios";
import { getCurrentDate } from "../../Utilitie";
import SuccessMsg from "../../Extra/SuccessMsg";
import FailedMsg from "../../Extra/FailedMsg";

const CrackInsertion = () => {
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;
  const [loading, setLoading] = useState("");
  const [error, setError] = useState("");
  const [result, setResult] = useState(false);
  const [show, setShow] = useState(false);
  const [entries, setEntries] = useState([]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${urlPrefix}get_m_section_master_cracks`
      );
      if (response.data.status === "ok") {
        setEntries(response.data.data);
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch stations:", error);
      setLoading(false);
      setError(true);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const [crackDate, setCrackDate] = useState(getCurrentDate());

  const handleChange = (index, key, value) => {
    setEntries((prev) => {
      const newEntries = [...prev];
      newEntries[index] = { ...newEntries[index], [key]: value };
      return newEntries;
    });
  };

  const handleClear = () => {
    setCrackDate("");
    setEntries((prev) => prev.map((entry) => ({ ...entry, no_of_crack: "" })));
  };

  const handleSubmit = async () => {
    if (!crackDate) {
      toast.error("Please select a date.");
      return;
    }
    const CrackData = entries.map((entry) => ({
      ...entry,
      crack_date: crackDate,
    }));

    try {
      const response = await fetch(`${urlPrefix}insert/t_cracks_hdr`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(CrackData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const updateOutput = await response.json();

      setResult(updateOutput);
      setShow(true);
      handleClear();
    } catch (error) {
      const updateOutput = {
        status: "failed",
        message: "Failed to Insert ",
      };
      setResult(updateOutput);
      setShow(true);
    }
  };

  const chunkArray = (array, chunkSize) => {
    const chunks = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
  };

  return (
    <div className="papaDiv">
      <h5 className="bg-dark text-white text-center p-2">
        Insert Data In Crack Table
      </h5>

      <div className="mb-3 text-center">
        <label className="form-label fw-bold">Select Crack Date:</label>
        <input
          type="date"
          className="form-control w-auto d-inline-block ms-2"
          value={crackDate}
          onChange={(e) => setCrackDate(e.target.value)}
        />
      </div>

      <div className="d-flex flex-wrap justify-content-center ">
        {chunkArray(entries, Math.round(entries.length / 3)).map(
          (chunk, chunkIndex) => (
            <div
              className="table-responsive papaDiv m-2 "
              key={chunkIndex}
              style={{ minWidth: "400px" }}
            >
              <table className="table table-bordered table-striped m-0 ">
                <thead className="table-dark text-center align-middle sticky-top">
                  <tr>
                    <th>SR NO.</th>
                    <th>SECTION NAME</th>
                    <th>NO OF CRACK</th>
                  </tr>
                </thead>
                <tbody>
                  {chunk.map((entry, index) => {
                    const globalIndex = chunkIndex * 8 + index;
                    return (
                      <tr key={globalIndex}>
                        <td>{entry.section_id}</td>
                        <td>{entry.section_name}</td>
                        <td>
                          <input
                            type="number"
                            className="form-control"
                            style={{
                              height: "26px",
                              padding: "2px 6px",
                              fontSize: "0.8rem",
                            }}
                            value={entry.no_of_crack || ""}
                            onChange={(e) =>
                              handleChange(
                                globalIndex,
                                "no_of_crack",
                                e.target.value
                              )
                            }
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )
        )}
      </div>

      <div className="text-center mt-4">
        <button
          className="btn btn-outline-danger m-2 px-5"
          onClick={handleClear}
        >
          Clear
        </button>
        <button
          className="btn btn-outline-success m-2 px-5"
          onClick={handleSubmit}
        >
          Insert
        </button>
      </div>
      <div className="p-3">
        {result && result.status === "ok" ? (
          <SuccessMsg
            head="Success"
            message={result.message}
            show={show}
            setShow={setShow}
          />
        ) : (
          result && (
            <FailedMsg
              head="Failed"
              message={result.message || "Failed to complete the task"}
              show={show}
              setShow={setShow}
            />
          )
        )}
      </div>
    </div>
  );
};

export default CrackInsertion;
